import { scrollToAnchor } from "#lib/scroll-utils"
import { cn } from "#lib/utils"
import { Link } from "lucide-react"
import { useLocation, useNavigate } from "react-router-dom"
import { Button } from "./button"

interface AnchorTitleProps {
  id: string
  children: React.ReactNode
  className?: string
}

export function AnchorTitle({ id, children, className }: AnchorTitleProps) {
  const location = useLocation()
  const navigate = useNavigate()

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    const newUrl = `${location.pathname}#${id}`
    navigate(newUrl, { replace: true })
    scrollToAnchor(id)
  }

  return (
    <div className={cn("group relative inline-flex items-center gap-2", className)}>
      {children}
      <Button
        variant="ghost"
        size="icon"
        className="h-6 w-6 opacity-0 transition-opacity group-hover:opacity-100"
        onClick={handleClick}
        aria-label={`Link to ${id}`}
      >
        <Link className="h-3.5 w-3.5 text-muted-foreground hover:text-foreground" />
      </Button>
    </div>
  )
}
